import { render, staticRenderFns } from "./MyCertificatesCard.vue?vue&type=template&id=f63a184a&scoped=true&"
import script from "./MyCertificatesCard.vue?vue&type=script&lang=ts&"
export * from "./MyCertificatesCard.vue?vue&type=script&lang=ts&"
import style0 from "./MyCertificatesCard.vue?vue&type=style&index=0&id=f63a184a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63a184a",
  null
  
)

export default component.exports